import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();
    this.loadingDom = document.querySelector('#loading');
    this.videoDom = document.querySelector('#loading video');
  }

  initEvents() {
    super.initEvents();
    this.bindEndHandler = this.endHandlder.bind(this);
    this.videoDom.addEventListener('ended', this.bindEndHandler);
  }

  endHandlder(event){

    this.videoDom.removeEventListener('ended', this.bindEndHandler);
    gsap.delayedCall(1, ()=>{
      this.loadingDom.classList.add('hide');
      this.pack.top.startIntro();
      gsap.delayedCall(.5, ()=> {
        this.pack.header.start();
      });
    });
  }

  start() {}

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
